import { rem } from 'polished';
import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';

export const Wrapper = styled.div`
    margin: ${rem(15)} 0 ${rem(45)} 0;
    padding: ${rem(30)} 0;

    @media (min-width: ${breakpoints.sm}px) {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    @media (min-width: ${breakpoints.md}px) {
        padding: 0;
    }
`;

export const Sections = styled.div`
    font-size: ${({ theme }) => theme.fontSizes.h6};
    display: flex;
    flex-direction: column;

    @media (min-width: ${breakpoints.sm}px) {
        width: 45%;
    }
`;

export const Section = styled.div<{ isMission?: boolean }>`
    margin-bottom: ${rem(40)};
`;

export const SectionHeader = styled.div<{ isMission?: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-family: ${({ theme }) => theme.fonts.fontSecondary};

    svg {
        margin-right: ${rem(14)};
        width: ${rem(20)};
        height: ${rem(20)};

        path {
            fill: ${({ theme }) => theme.colors.primary};
        }
    }
`;

export const SectionDescription = styled.div`
    padding-top: ${rem(15)};
    margin-left: ${rem(30)};
    color: ${({ theme }) => theme.colors.grey};
    line-height: ${rem(30)};
`;
